"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var confirmMarkAsPhishing_1 = require("./helpers/confirmMarkAsPhishing");
var filterRowKeysByExistence_1 = require("./helpers/filterRowKeysByExistence");
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
var getItemIdsFromConversations_1 = require("owa-mail-list-store/lib/utils/getItemIdsFromConversations");
var markItemsAsPhishingBasedOnItemIds_1 = require("./helpers/markItemsAsPhishingBasedOnItemIds");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_mail_actions_1 = require("owa-mail-actions");
/**
 * Mark the conversation as phishing with the confirm dialog
 * @param conversationRowKeys the specified conversation ids to be marked as phishing
 * @param tableView that contains the rows
 * @param actionSource the action source where this action is triggered from
 * @return a function which shows the confirmation dialog
 */
function markConversationsAsPhishingFromTable(conversationRowKeys, tableView, actionSource) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing_1.default(function () {
        markConversationsAsPhishingInternal(conversationRowKeys, tableView, actionSource);
    });
}
exports.default = markConversationsAsPhishingFromTable;
/**
 * mark conversations as phishing action
 * @param conversationRowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source where this action is triggered from
 */
function markConversationsAsPhishingInternal(conversationRowKeys, tableView, actionSource) {
    // Since rows may have been deleted from the table while the confirm dialog was open,
    // we need to validate the rows exist before proceeding
    var filteredRowKeys = filterRowKeysByExistence_1.default(conversationRowKeys, tableView);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(conversationRowKeys, tableView);
    // Get the de-duped conversation ids
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    // Get all itemIds inside the conversations
    var itemIdsToUpdate = getItemIdsFromConversations_1.default(filteredRowKeys, tableView.id);
    markItemsAsPhishingBasedOnItemIds_1.default(itemIdsToUpdate, actionSource, function () {
        // raise stitch to delete conversation from reading pane and list view
        stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, tableView);
    });
    owa_mail_actions_1.userMailInteractionAction('MarkAsPhishing', instrumentationContexts);
}
//# sourceMappingURL=markConversationsAsPhishingFromTable.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markConversationsAsPhishingFromTable.js
// module id = 5611
// module chunks = 62